import React, { useState, useRef, useEffect } from "react";

const OtpVerifyPage = ({ mobileOrEmail, onOtpSubmit, onResendOtp, loading, isLoginModalOpen }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleResend = () => {
    onResendOtp();
    setTimeLeft(60);

    // Clear OTP state
    setOtp(["", "", "", "", "", ""]);

    // Clear the actual input boxes
    inputsRef.current.forEach((input) => {
      if (input) input.value = "";
    });

    // Focus first input again
    inputsRef.current[0]?.focus();
  };

  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    onOtpSubmit(enteredOtp);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();

    if (/^\d+$/.test(pasteData)) {
      const digits = pasteData.split("").slice(0, 6);
      const newOtp = [...otp];

      digits.forEach((d, i) => {
        newOtp[i] = d;
        if (inputsRef.current[i]) {
          inputsRef.current[i].value = d;
        }
      });

      setOtp(newOtp);
      const nextIndex = digits.length < 6 ? digits.length : 5;
      inputsRef.current[nextIndex]?.focus();
    }
  };


  return (
    <div className={`${isLoginModalOpen ? '' : 'min-h-screen'} flex items-center justify-center bg-gray-100 rounded-xl`}>
      <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-md border py-6">
        <div className="flex justify-center my-5">
          {/* <img src={Logo} alt="ConceptsByShrayansh" className="h-10" /> */}
        </div>

        <h3 className="">Verify</h3>
        <p className="pb-3">
          Please enter the code we just sent to <strong>{mobileOrEmail}</strong>
        </p>

        <form onSubmit={handleSubmit}>
          <label className="text-sm font-medium text-gray-700 mb-2 block">
            OTP
          </label>
          <div className="flex justify-start gap-3 mb-3">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputsRef.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={index === 0 ? handlePaste : undefined}
                className="w-12 h-12 text-center text-lg border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            ))}

          </div>

          <div className="flex justify-start items-center mb-4 text-sm">
            {timeLeft > 0 ? (
              <p className="text-gray-500">
                Resend code in <span className="font-semibold text-gray-900">{formatTime(timeLeft)}</span>
              </p>
            ) : (
              <p className="text-gray-500">
                Didn't receive the code?{" "}
                <button
                  type="button"
                  className="font-medium text-gray-900 hover:underline"
                  onClick={handleResend}
                >
                  Resend Code
                </button>
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 text-white rounded flex justify-center items-center bg-[var(--primary-button)] hover:opacity-90 disabled:opacity-60"
          >
            {loading && (
              <div className="border-t-transparent border-white border-2 rounded-full w-5 h-5 animate-spin mr-2"></div>
            )}
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default OtpVerifyPage;
